// extracted by mini-css-extract-plugin
export var formContainer = "styles-module--formContainer--2s1yr";
export var contents = "styles-module--contents--3V6zQ";
export var containerError = "styles-module--containerError--dUCdj";
export var iconError = "styles-module--iconError--3Aqbo";